import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { ApiErrorResponse } from "@whatslly/types/ApiErrorResponse";

export const SMARTERS_SOLUTION_ID = "784450763512006";

export const WhatsappBusinessApiGetAccessTokenBody = Type.Object({
  code: Type.String(),
  orgId: Type.String(),
  wabaId: Type.String({ minLength: 1 }),
  businessId: Type.Optional(Type.String()),
  solutionId: Type.Optional(Type.Literal(SMARTERS_SOLUTION_ID)),
});

export type WhatsappBusinessApiGetAccessTokenBody = TypeBoxToType<typeof WhatsappBusinessApiGetAccessTokenBody>;

const WhatsappBusinessApiGetAccessTokenResponseSuccess = Type.Object({
  success: Type.Literal(true),
});

export const WhatsappBusinessApiGetAccessTokenResponse = Type.Union([ApiErrorResponse, WhatsappBusinessApiGetAccessTokenResponseSuccess]);

export type WhatsappBusinessApiGetAccessTokenResponse = TypeBoxToType<typeof WhatsappBusinessApiGetAccessTokenResponse>;
